export default __webpack_public_path__ + "static/CAM-symbol-color-b9b6c50c97d2707bf2f9f2e3c384cb00.png";